import { ElementTemplateDetailsPage, ElementTemplateListPage } from 'elements/pages';

import { elementTemplateDetailsPath, elementTemplateListPath } from './routePaths';

export const elementTemplateList = {
  path: elementTemplateListPath(),
  exact: true,
  isPrivate: true,
  element: <ElementTemplateListPage />,
};

export const elementTemplateDetails = {
  path: elementTemplateDetailsPath(),
  exact: true,
  isPrivate: true,
  element: <ElementTemplateDetailsPage />,
};
